/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost } from '../fn/construction-day-report/api-v-0-constructiondayreport-correct-working-times-take-user-hours-report-id-user-id-post';
import { ApiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-correct-working-times-take-user-hours-report-id-user-id-post';
import { apiV0ConstructiondayreportCreateConstructionDayReportPost$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-construction-day-report-post-json';
import { ApiV0ConstructiondayreportCreateConstructionDayReportPost$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-construction-day-report-post-json';
import { apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-construction-day-report-post-plain';
import { ApiV0ConstructiondayreportCreateConstructionDayReportPost$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-construction-day-report-post-plain';
import { apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-from-id-working-entry-id-report-type-approve-post';
import { ApiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-from-id-working-entry-id-report-type-approve-post';
import { apiV0ConstructiondayreportCreateReportPost$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-report-post-json';
import { ApiV0ConstructiondayreportCreateReportPost$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-report-post-json';
import { apiV0ConstructiondayreportCreateReportPost$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-report-post-plain';
import { ApiV0ConstructiondayreportCreateReportPost$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-report-post-plain';
import { apiV0ConstructiondayreportCreateReportsPost$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-reports-post-json';
import { ApiV0ConstructiondayreportCreateReportsPost$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-reports-post-json';
import { apiV0ConstructiondayreportCreateReportsPost$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-reports-post-plain';
import { ApiV0ConstructiondayreportCreateReportsPost$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-create-reports-post-plain';
import { apiV0ConstructiondayreportDeleteConstructionDayReportPost } from '../fn/construction-day-report/api-v-0-constructiondayreport-delete-construction-day-report-post';
import { ApiV0ConstructiondayreportDeleteConstructionDayReportPost$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-delete-construction-day-report-post';
import { apiV0ConstructiondayreportExistingReportInfosPost$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-existing-report-infos-post-json';
import { ApiV0ConstructiondayreportExistingReportInfosPost$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-existing-report-infos-post-json';
import { apiV0ConstructiondayreportExistingReportInfosPost$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-existing-report-infos-post-plain';
import { ApiV0ConstructiondayreportExistingReportInfosPost$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-existing-report-infos-post-plain';
import { apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-company-get-json';
import { ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-company-get-json';
import { apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-company-get-plain';
import { ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-company-get-plain';
import { apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-id-get-json';
import { ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-id-get-json';
import { apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-id-get-plain';
import { ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-by-id-get-plain';
import { apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-for-construction-site-get-json';
import { ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-for-construction-site-get-json';
import { apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-for-construction-site-get-plain';
import { ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-get-construction-day-reports-for-construction-site-get-plain';
import { apiV0ConstructiondayreportReportIdDelete } from '../fn/construction-day-report/api-v-0-constructiondayreport-report-id-delete';
import { ApiV0ConstructiondayreportReportIdDelete$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-report-id-delete';
import { apiV0ConstructiondayreportSignConstructionDayReportPost } from '../fn/construction-day-report/api-v-0-constructiondayreport-sign-construction-day-report-post';
import { ApiV0ConstructiondayreportSignConstructionDayReportPost$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-sign-construction-day-report-post';
import { apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json } from '../fn/construction-day-report/api-v-0-constructiondayreport-update-construction-day-report-post-json';
import { ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-update-construction-day-report-post-json';
import { apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain } from '../fn/construction-day-report/api-v-0-constructiondayreport-update-construction-day-report-post-plain';
import { ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain$Params } from '../fn/construction-day-report/api-v-0-constructiondayreport-update-construction-day-report-post-plain';
import { ConstructionDayReport } from '../models/construction-day-report';
import { ReportCreationResult } from '../models/report-creation-result';
import { WorkingEntry } from '../models/working-entry';

@Injectable({ providedIn: 'root' })
export class ConstructionDayReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0ConstructiondayreportGetConstructionDayReportsByIdGet()` */
  static readonly ApiV0ConstructiondayreportGetConstructionDayReportsByIdGetPath = '/api/v0/constructiondayreport/getConstructionDayReportsById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Response(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ConstructionDayReport>> {
    const obs = apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Params, context?: HttpContext): Observable<ConstructionDayReport> {
    const resp = this.apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConstructionDayReport>): ConstructionDayReport => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json$Response(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ConstructionDayReport>> {
    const obs = apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json$Params, context?: HttpContext): Observable<ConstructionDayReport> {
    const resp = this.apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConstructionDayReport>): ConstructionDayReport => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet()` */
  static readonly ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGetPath = '/api/v0/constructiondayreport/getConstructionDayReportsByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain$Response(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
    const obs = apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<ConstructionDayReport>> {
    const resp = this.apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConstructionDayReport>>): Array<ConstructionDayReport> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Response(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
    const obs = apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json(params?: ApiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<ConstructionDayReport>> {
    const resp = this.apiV0ConstructiondayreportGetConstructionDayReportsByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConstructionDayReport>>): Array<ConstructionDayReport> => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet()` */
  static readonly ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGetPath = '/api/v0/constructiondayreport/getConstructionDayReportsForConstructionSite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Response(params?: ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
    const obs = apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain(params?: ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Params, context?: HttpContext): Observable<Array<ConstructionDayReport>> {
    const resp = this.apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConstructionDayReport>>): Array<ConstructionDayReport> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Response(params?: ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionDayReport>>> {
    const obs = apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json(params?: ApiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Params, context?: HttpContext): Observable<Array<ConstructionDayReport>> {
    const resp = this.apiV0ConstructiondayreportGetConstructionDayReportsForConstructionSiteGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConstructionDayReport>>): Array<ConstructionDayReport> => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportUpdateConstructionDayReportPost()` */
  static readonly ApiV0ConstructiondayreportUpdateConstructionDayReportPostPath = '/api/v0/constructiondayreport/updateConstructionDayReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain$Response(params?: ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain(params?: ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConstructiondayreportUpdateConstructionDayReportPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Response(params?: ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json(params?: ApiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConstructiondayreportUpdateConstructionDayReportPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportExistingReportInfosPost()` */
  static readonly ApiV0ConstructiondayreportExistingReportInfosPostPath = '/api/v0/constructiondayreport/existingReportInfos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportExistingReportInfosPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportExistingReportInfosPost$Plain$Response(params?: ApiV0ConstructiondayreportExistingReportInfosPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkingEntry>>> {
    const obs = apiV0ConstructiondayreportExistingReportInfosPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportExistingReportInfosPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportExistingReportInfosPost$Plain(params?: ApiV0ConstructiondayreportExistingReportInfosPost$Plain$Params, context?: HttpContext): Observable<Array<WorkingEntry>> {
    const resp = this.apiV0ConstructiondayreportExistingReportInfosPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkingEntry>>): Array<WorkingEntry> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportExistingReportInfosPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportExistingReportInfosPost$Json$Response(params?: ApiV0ConstructiondayreportExistingReportInfosPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkingEntry>>> {
    const obs = apiV0ConstructiondayreportExistingReportInfosPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportExistingReportInfosPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportExistingReportInfosPost$Json(params?: ApiV0ConstructiondayreportExistingReportInfosPost$Json$Params, context?: HttpContext): Observable<Array<WorkingEntry>> {
    const resp = this.apiV0ConstructiondayreportExistingReportInfosPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkingEntry>>): Array<WorkingEntry> => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportCreateReportPost()` */
  static readonly ApiV0ConstructiondayreportCreateReportPostPath = '/api/v0/constructiondayreport/createReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportPost$Plain$Response(params?: ApiV0ConstructiondayreportCreateReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCreationResult>> {
    const obs = apiV0ConstructiondayreportCreateReportPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportPost$Plain(params?: ApiV0ConstructiondayreportCreateReportPost$Plain$Params, context?: HttpContext): Observable<ReportCreationResult> {
    const resp = this.apiV0ConstructiondayreportCreateReportPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportCreationResult>): ReportCreationResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateReportPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportPost$Json$Response(params?: ApiV0ConstructiondayreportCreateReportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCreationResult>> {
    const obs = apiV0ConstructiondayreportCreateReportPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateReportPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportPost$Json(params?: ApiV0ConstructiondayreportCreateReportPost$Json$Params, context?: HttpContext): Observable<ReportCreationResult> {
    const resp = this.apiV0ConstructiondayreportCreateReportPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportCreationResult>): ReportCreationResult => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportCreateConstructionDayReportPost()` */
  static readonly ApiV0ConstructiondayreportCreateConstructionDayReportPostPath = '/api/v0/constructiondayreport/createConstructionDayReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain$Response(params?: ApiV0ConstructiondayreportCreateConstructionDayReportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain(params?: ApiV0ConstructiondayreportCreateConstructionDayReportPost$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConstructiondayreportCreateConstructionDayReportPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateConstructionDayReportPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateConstructionDayReportPost$Json$Response(params?: ApiV0ConstructiondayreportCreateConstructionDayReportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConstructiondayreportCreateConstructionDayReportPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateConstructionDayReportPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateConstructionDayReportPost$Json(params?: ApiV0ConstructiondayreportCreateConstructionDayReportPost$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConstructiondayreportCreateConstructionDayReportPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportCreateReportsPost()` */
  static readonly ApiV0ConstructiondayreportCreateReportsPostPath = '/api/v0/constructiondayreport/createReports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateReportsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportsPost$Plain$Response(params?: ApiV0ConstructiondayreportCreateReportsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = apiV0ConstructiondayreportCreateReportsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateReportsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportsPost$Plain(params?: ApiV0ConstructiondayreportCreateReportsPost$Plain$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.apiV0ConstructiondayreportCreateReportsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateReportsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportsPost$Json$Response(params?: ApiV0ConstructiondayreportCreateReportsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = apiV0ConstructiondayreportCreateReportsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateReportsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructiondayreportCreateReportsPost$Json(params?: ApiV0ConstructiondayreportCreateReportsPost$Json$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.apiV0ConstructiondayreportCreateReportsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportSignConstructionDayReportPost()` */
  static readonly ApiV0ConstructiondayreportSignConstructionDayReportPostPath = '/api/v0/constructiondayreport/signConstructionDayReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportSignConstructionDayReportPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportSignConstructionDayReportPost$Response(params?: ApiV0ConstructiondayreportSignConstructionDayReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructiondayreportSignConstructionDayReportPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportSignConstructionDayReportPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportSignConstructionDayReportPost(params?: ApiV0ConstructiondayreportSignConstructionDayReportPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructiondayreportSignConstructionDayReportPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportDeleteConstructionDayReportPost()` */
  static readonly ApiV0ConstructiondayreportDeleteConstructionDayReportPostPath = '/api/v0/constructiondayreport/deleteConstructionDayReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportDeleteConstructionDayReportPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportDeleteConstructionDayReportPost$Response(params?: ApiV0ConstructiondayreportDeleteConstructionDayReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructiondayreportDeleteConstructionDayReportPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportDeleteConstructionDayReportPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportDeleteConstructionDayReportPost(params?: ApiV0ConstructiondayreportDeleteConstructionDayReportPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructiondayreportDeleteConstructionDayReportPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportReportIdDelete()` */
  static readonly ApiV0ConstructiondayreportReportIdDeletePath = '/api/v0/constructiondayreport/{reportId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportReportIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportReportIdDelete$Response(params: ApiV0ConstructiondayreportReportIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructiondayreportReportIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportReportIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportReportIdDelete(params: ApiV0ConstructiondayreportReportIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructiondayreportReportIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost()` */
  static readonly ApiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPostPath = '/api/v0/constructiondayreport/correctWorkingTimes/{takeUserHours}/{reportId}/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Response(params: ApiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost(params: ApiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructiondayreportCorrectWorkingTimesTakeUserHoursReportIdUserIdPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost()` */
  static readonly ApiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePostPath = '/api/v0/constructiondayreport/createFromId/{workingEntryId}/{reportType}/{approve}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Response(params: ApiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost(params: ApiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructiondayreportCreateFromIdWorkingEntryIdReportTypeApprovePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
